export default {
    attachmentsList: {
        remove: 'ukloni',
        addButton: '+ Dodaj privitak',
        limitReached: 'Dosegnut limit (20)',
        addTitle: 'Dodaj privitak',
        urlLabel: 'URL',
    },
}
